import {
  ROUTE_KEY_ATTRIBUTES,
  ROUTE_KEY_BRANDS,
  ROUTE_KEY_ONLY_AVAILABLE,
  ROUTE_KEY_PRICE,
  ROUTE_KEY_PRICE_TYPE,
} from './types';

export function clearUrlFromFilterParams(url: URL) {
  const attributeKeys = Array.from(url.searchParams.keys()).filter(k =>
    k.startsWith(ROUTE_KEY_ATTRIBUTES)
  );
  if (attributeKeys.length > 0) {
    for (const key of attributeKeys) {
      if (!url.searchParams.has(key)) continue;
      url.searchParams.delete(key);
    }
  }

  url.searchParams.delete(ROUTE_KEY_BRANDS);
  url.searchParams.delete(ROUTE_KEY_PRICE_TYPE);
  url.searchParams.delete(ROUTE_KEY_PRICE);
  url.searchParams.delete(ROUTE_KEY_ONLY_AVAILABLE);
}
